const { licenseStatusModal: { actions : licenseStatusModalActions } } = window.actions;
App.Updater = {
    mapStop: false,
    map: null,
    mapMain: null
};

App.init = function () {
  try {
    Monet.Configurations.ajaxGlobalSetup();
    Greenmile.UnsupportedBrowser.check ();

    if (!Greenmile.UnsupportedBrowser.isUnsupportedBrowser) {

        App.Objects = App.Objects || {};
        App.Objects.RouteMonitor = new App.Routers.RouteMonitor ();
        new App.Routers.I18NLocale();
        new App.Routers.I18NResource();
        new App.Routers.Welcome();
        new App.Routers.LocationType();
        new App.Routers.Location();
        new App.Routers.Users();
        new App.Routers.Equipment();
        new App.Routers.EquipmentType();
        new App.Routers.Driver();
        new App.Routers.Order();
        new App.Routers.DriverProfileCost();
        new App.Routers.TimeWindowType();
        new App.Routers.ServiceTimeType();
        new App.Routers.ReasonCode();
        new App.Routers.CancelCode();
        new App.Routers.MapConfiguration();
        new App.Routers.StopType();
        new App.Routers.UndeliverableCode();
        new App.Routers.LocationOverrideTimeWindow();
        new App.Routers.TimeWindowTypeDays();
        new App.Routers.RouteDetails();
        new App.Routers.MongoHost();
        new App.Routers.MongoHost();
        new App.Routers.EventLog();
        new App.Routers.Event();
        App.Objects.EventNotifications = new App.Routers.EventNotifications();
        new App.Routers.EventType();
        new App.Routers.AccountType();
        new App.Routers.OrderClass();
        new App.Routers.DelayType();
        new App.Routers.SmartGeocode();
        new App.Routers.MassiveSmartGeocode();
        new App.Routers.Group();
        new App.Routers.HoursOfServiceType();
        new App.Routers.Organization();
        new App.Routers.Route();
        new App.Routers.Stop();
        new App.Routers.AutoArriveConfiguration();
        new App.Routers.AutoArriveLog();
        App.Objects.Reports = new App.Routers.Reports();
        App.Objects.ServiceTimeUpdates = new App.Routers.ServiceTimeUpdates();
        new App.Routers.IPRangeProfile();
        new App.Routers.Configuration();

        new App.Routers.Task();
        new App.Routers.TaskType();
        new App.Routers.TrackEquipmentMaps();
        new App.Routers.RouteProgress();
        new App.Routers.Geofence();
        App.Objects.GroupPermissions = new App.Routers.GroupPermissions();
        new App.Routers.PendingOrdersNotification();
        new App.Routers.DataImport();
        new App.Routers.DataImportOld();
        new App.Routers.Survey();
        new App.Routers.SMSConfiguration();
        new App.Routers.RouteSuggestion();

        App.Objects.GeotabSync = new App.Routers.GeotabSync();
        App.Objects.EnovarBoard = new App.Routers.EnovarBoard();
        new App.Routers.Tag();
        new App.Routers.Sku();
        new App.Routers.DeviceStatistic();
        new App.Routers.HoursOfServiceTypeDays();
        new App.Routers.GlobalConfiguration();
        new App.Routers.PaymentMethod();
        new App.Routers.PaymentMethodAllowed();
        new App.Routers.Bank();
        new App.Routers.SamlConfiguration();
        new App.Routers.KronosConfiguration();
        new App.Routers.KronosLog();
        new App.Routers.ReportTemplate();
        new App.Routers.PanelBuilder();
        new App.Routers.Panel();
        new App.Routers.RouteActionsConfiguration();
        new App.Routers.ProactiveRouteOptConfig();
        new App.Routers.ManagersApprovalRequestConfiguration();
        new App.Routers.TaskSchedulerConfiguration();
        new App.Routers.SizeAlias();
        new App.Routers.PasswordPolicy();
        new App.Routers.SkuOrganizationPriceList();
        new App.Routers.GeotabGeofenceImportLog();
        new App.Routers.HOSGeoTabSyncLog();
        new App.Routers.NotificationSubscription();
        new App.Routers.Sku();
        new App.Routers.PendingOrder();
        new App.Routers.CheckpointItemReason();
        new App.Routers.DocumentSendingConfiguration();
        new App.Routers.TaskStatus();
        new App.Routers.TaskReason();
        new App.Routers.TaskResolution();
        new App.Routers.Ticket();
        new App.Routers.SecurityPolicy();
        new App.Routers.TicketResolution();
        new App.Routers.TicketType();
        new App.Routers.WGLNIntegrationLog();
        new App.Routers.LocalzIntegrationLog();
        new App.Routers.EventLogHttpAction();

        Greenmile.Platform.check();
        Monet.I18n.checkResources();
    }
  } catch (error) {
    console.log(error.message)
  }
};

App.mapUpdate = function mapUpdate() {
    if (Monet.Session.sessionStorage.mapmain) {
        const mapMain = JSON.parse(Monet.Session.sessionStorage.mapmain);
        const updateMainMap = new Greenmile.Storage.StoreMapPosition();
        updateMainMap.setPosition(mapMain.center, mapMain.zoom);
    }

    const updater = new Monet.Maps.Updater();
    updater.go();
    if (Monet.Security.checkKeyIsEnabled(['ROUTE_SUGGESTION'])) {
        if ( App.Objects.RouteMonitorRoutes ) {
            App.Objects.RouteMonitorRoutes.getPendingOrders();
        }
        App.Objects.EventNotifications.getEvents();
    }
};

App.licenseStatusUpdate = function() {
  var request = new Monet.Ajax();
  request.url = "/License/Status";
  request.success = function(response) {
    let action = {};
    const data = response || {};
    if (data.message) {
      action.type = licenseStatusModalActions.licenseStatusModalShowed;
      action.payload = {
        resource: data.message,
        isCancelable: data.message === 'License.Warning' ? true : false
      }
    } else {
      action.type = licenseStatusModalActions.licenseStatusModalClosed;
    }
    window.GreenmileReduxStore.dispatch(action);
  }
  request.send();
};

App.initializePendo = function (payload) {
  if (!pendo) return;

  const { hashedId, preferedLocale } = payload?.loggedUser || {};
  const tenant = Greenmile.Utils.getTenant();
  const GM_LiveVersion = App.Version.GMLVersionNumber;
  const GM_UserLocale = preferedLocale?.language;

  pendo.identify({
    visitor: {
      id: hashedId,
      GM_UserLocale
    },
    account: {
      id: tenant,
      GM_LiveVersion
    }
  });

  pendo.initialize();
}

window.greenmileIntervalId = null;
window.greenmiletimeoutId = null;
window.greenmileLogoffTimeoutId = null;

App.checkUpdates = function() {
    const { liveDefaultRefreshIntervalSecs } = Monet.Session.Configurations ?? {};
    const timeToUpdate = liveDefaultRefreshIntervalSecs ? liveDefaultRefreshIntervalSecs * 1000 : 60000;

    if(window.greenmiletimeoutId) {
      clearTimeout(window.greenmiletimeoutId);
      window.greenmiletimeoutId = null;
    }

    if(window.greenmileIntervalId) {
      clearInterval(window.greenmileIntervalId);
    }

    App.mapUpdate();
    App.licenseStatusUpdate();
    window.greenmileIntervalId = setInterval(App.checkUpdates,  timeToUpdate);

    Monet.Session.Configurations.timeToUpdate = timeToUpdate;
};

App.jqueryConfigurations = function() {

    Monet.Configurations.ajaxGlobalSetup();
    Monet.Configurations.ajaxStart();

    Monet.Configurations.ajaxStop();
    Monet.Configurations.ajaxError();

    $.cookie.json = true;

    $.fn.removeWithLeakage = function () {
        this.each(function (i, e) {

            $("*", e).add([ e ]).each(function () {
                $.event.remove(this);
                $(e).empty();
            });

            if (e.parentNode) {
                e.parentNode.removeChild(e);
            }
        });
    };

};
